import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const FooterOrganizerContext = createContext(null);

export function FooterOrganizerProvider({ children }) {
  const [organizer, setOrganizer] = useState(null);

  const value = useMemo(
    () => ({ organizer, setOrganizer }),
    [organizer],
  );

  return (
    <FooterOrganizerContext.Provider value={value}>
      {children}
    </FooterOrganizerContext.Provider>
  );
}

export function useFooterOrganizer() {
  const ctx = useContext(FooterOrganizerContext);
  return ctx ? ctx.organizer : null;
}

export function usePublishFooterOrganizer(organizer) {
  const ctx = useContext(FooterOrganizerContext);
  const setOrganizer = ctx?.setOrganizer;

  const name = organizer?.name ?? null;
  const email = organizer?.email ?? null;
  const phone = organizer?.phone ?? null;
  const cancellationPolicy = organizer?.cancellationPolicy ?? null;
  const terms = organizer?.terms ?? null;

  const stable = useMemo(() => {
    if (!name && !email && !phone && !cancellationPolicy && !terms) {
      return null;
    }
    return { name, email, phone, cancellationPolicy, terms };
  }, [name, email, phone, cancellationPolicy, terms]);

  useEffect(() => {
    if (!setOrganizer) return undefined;
    setOrganizer(stable);
    return () => setOrganizer(null);
  }, [setOrganizer, stable]);
}

export function useClearFooterOrganizer() {
  const ctx = useContext(FooterOrganizerContext);
  const setOrganizer = ctx?.setOrganizer;
  return useCallback(() => {
    if (setOrganizer) setOrganizer(null);
  }, [setOrganizer]);
}
